module.exports = __webpack_public_path__ + "img/fda-envelope-rounded.ac435b31.png";